export default __webpack_public_path__ + "static/media/connected.695981b8.wav";